import MDButton from "components/MDButton";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useMaterialUIController } from "context";
import { useDispatch, useSelector } from "react-redux";
import ImagePicker from "components/ApnaUploader";
import { Cancel, CurrencyRupee, Percent } from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SkLoading from "components/SkLoading";
import MDInput from "components/MDInput";
import {
  Card,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  Switch,
} from "@mui/material";
import { getAllBlogs } from "redux/festures/blogSlice";
import { updateBlog } from "redux/festures/blogSlice";
import { createPostBlogs } from "redux/festures/blogSlice";
import { handleAlert } from "redux/festures/alertSlice";
import ApnaSelect from "components/ApnaSelect/ApnaSelect";
import { getCategory } from "redux/festures/categorySlice";
import { formattedDateServer } from "Utils/dateFunc";
import { createCoupons } from "redux/festures/couponsSlice";
import { getAllCoupons } from "redux/festures/couponsSlice";
import { updateCoupons } from "redux/festures/couponsSlice";
import SkDatePicker from "components/SkDataPicker";
import axios from "axios";
import AstrieskIcon from "components/AstrieskIcon";
import { getEcomCategory } from "redux/festures/categorySlice";
import InfiniteApnaSelect from "components/ApnaSelect/InfiniteApnaSelect";
const Form = ({ isOpenUpdate, setIsOpenUpdate, setIsOpen, type, filter }) => {
  ;
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [couponData, setCouponData] = useState({
    couponName: "",
    couponCode: "",
    discountType: "",
    discountValue: "",
    applyCouponOn: [],
    couponPercent: "",
    minOrderPrice: "",
    maxDiscountPrice: "",
    couponQuantity: "",
    backgroundColourCode: "",
    taskColourCode: "",

    // expiryDate: "",
    startDate: "",
    validity: "",
    // categoryId: "",
  });
  // const [isBlogContent, setIsBlogContent] = useState("");
  const [isCouponsIcon, setIsCouponsIcon] = useState("");
  const [isShow, setIsShow] = useState("");
  const [isSelection, setIsSelection] = useState("category");
  const [isCategory, setIsCategory] = useState([]);
  const [isECategory, setIsECategory] = useState([]);
  const [isProducts, setIsProducts] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  //   const [isBrandShowHome, setIsBrandShowHome] = useState(false);
  const admin = localStorage.getItem("admin_id");
  const dispatch = useDispatch();
  // const { Loading, singleBlogs } = useSelector((data) => ({ ...data?.isBlogs }));
  // const { category, EcomCategory } = useSelector((state) => ({
  //   category: state.isCategory.category,
  //   EcomCategory: state.isECategory.EcomCategory,
  // }));
  const { category, EcomCategory } = useSelector((data) => ({ ...data?.isCategory }));

  const { Loading, singleCoupons, createupdateLoading } = useSelector((data) => ({
    ...data?.isCoupons,
  }));
  // const { AllProducts } = useSelector((state) => ({ ...state.isProducts }));
  useEffect(() => {
    dispatch(getCategory(`${process.env.REACT_APP_APII}/getAllCategoryByAdmin/${admin}`));

    // dispatch(getAllProducts(`/getAllProduct`));
  }, []);
  useEffect(() => {
    dispatch(
      getEcomCategory(`${process.env.REACT_APP_APII}/eCommerce/getAllCategoryByAdmin/${admin}`)
    );

    // dispatch(getAllProducts(`/getAllProduct`));
  }, []);
  ;
  ;
  ;
  useEffect(() => {
    if (singleCoupons && isOpenUpdate) {
      // Set coupon icon
      setIsShow(singleCoupons?.icon || "");
      setIsCouponsIcon(singleCoupons?.icon || "");
      
      // Set categories based on type
      if (Array.isArray(singleCoupons?.categoryId)) {
        const ids = singleCoupons.categoryId
          .map((item) => (typeof item === "string" ? item : item?._id))
          .filter(Boolean);
        setIsCategory(ids);
      }

      if (Array.isArray(singleCoupons?.eComCategoryId)) {
        const ids = singleCoupons.eComCategoryId
          .map((item) => (typeof item === "string" ? item : item?._id))
          .filter(Boolean);
        setIsECategory(ids);
        // Also set isCategory for eCom categories to work with the select component
        setIsCategory(ids);
      }

      setCouponData((prev) => {
        // Handle applyOn field - it could be string, array, or undefined
        let applyOnValue = [];
        if (singleCoupons?.applyOn) {
          if (Array.isArray(singleCoupons.applyOn)) {
            applyOnValue = singleCoupons.applyOn;
          } else if (typeof singleCoupons.applyOn === 'string') {
            applyOnValue = [singleCoupons.applyOn];
          } else if (singleCoupons.applyOn[0]) {
            applyOnValue = [singleCoupons.applyOn[0]];
          }
        }
        
        const newData = {
          ...prev,
          couponName: singleCoupons?.couponName || "",
          couponCode: singleCoupons?.couponCode || "",
          discountType: singleCoupons?.discountType || "",
          discountValue: singleCoupons?.discountValue || "",
          applyCouponOn: applyOnValue,
          couponPercent: singleCoupons?.couponPercent || "",
          minOrderPrice: singleCoupons?.minOrderPrice || "",
          maxDiscountPrice: singleCoupons?.maxDiscountPrice || "",
          couponQuantity: singleCoupons?.couponQuantity || "",
          backgroundColourCode: singleCoupons?.backgroundColourCode || "",
          taskColourCode: singleCoupons?.taskColourCode || "",
          startDate: singleCoupons?.startDate ? formattedDateServer(new Date(singleCoupons.startDate)) : "",
          validity: singleCoupons?.validity || "",
        };
        
        return newData;
      });
    } else {
      // Reset form when not updating
      setIsShow("");
      setIsCouponsIcon("");
      setIsProducts([]);
      setIsCategory([]);
      setIsECategory([]);
      setCouponData((prev) => ({
        ...prev,
        couponName: "",
        couponCode: "",
        discountType: "",
        discountValue: "",
        applyCouponOn: [],
        couponPercent: "",
        minOrderPrice: "",
        maxDiscountPrice: "",
        couponQuantity: "",
        backgroundColourCode: "",
        taskColourCode: "",
        startDate: "",
        validity: "",
      }));
    }
  }, [singleCoupons, isOpenUpdate]);
  ;
 const handleForm = (e) => {
  const { name, value } = e.target;

  // Numeric fields check
  if (
    name === "validity" ||
    name === "couponQuantity" ||
    name === "maxDiscountPrice" ||
    name === "minOrderPrice" ||
    name === "couponPercent"
  ) {
    setCouponData((prev) => ({
      ...prev,
      [name]: isNaN(parseInt(value[value.length - 1]))
        ? value.length === 1
          ? ""
          : value.slice(0, value.length - 1)
        : value,
    }));
  } else {
    // For text fields — remove emojis
    const cleanValue = value.replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]|\uFE0F)/g,
      ""
    );

    setCouponData((prev) => ({
      ...prev,
      [name]: cleanValue,
    }));
  }
};


  // const handleFormSubmit = (e) => {
  //   e.preventDefault();
  //   // console.log({
  //   //   ...couponData,
  //   //   category: isCategory,
  //   //   products: isProducts,
  //   //   icons: isCouponsIcon,
  //   // });
  //   if (isCategory !== "" || isShow !== "") {
  //     if (isOpenUpdate) {
  //       const formData = new FormData();
  //       // if (isSelection === "product")
  //       //   isProducts &&
  //       //     isProducts?.length > 0 &&
  //       //     isProducts.map((x) => formData.append("product", x));
  //       if (type === "CATEGORY") {
  //         isCategory &&
  //           isCategory?.length > 0 &&
  //           isCategory.map((x) => formData.append("categoryId", x));
  //       }
  //       if (type === "ECOM_CATEGORY") {
  //         isCategory &&
  //           isCategory?.length > 0 &&
  //           isCategory.map((x) => formData.append("eComCategoryId", x));
  //       }

  //       formData.append("icon", isCouponsIcon);
  //       

  //       couponData && Object.entries(couponData).map(([key, value]) => formData.append(key, value));
  //       
  //       dispatch(
  //         updateCoupons({
  //           url: `${process.env.REACT_APP_APII}/updateCoupon/${singleCoupons?._id}/${admin}`,
  //           data: formData,
  //         })
  //       ).then((data) => {
  ;
  //         dispatch(
  //           handleAlert({
  //             isOpen: true,
  //             type: `${data?.payload?.success ? "success" : "error"}`,
  //             msg: data?.payload?.message,
  //           })
  //         );
  //         if (data?.payload?.success) {
  //           setIsOpen(false);
  //           setIsOpenUpdate(false);
  //           setIsShow("");
  //           setIsProducts([]);
  //           setIsCategory([]);
  //           // setIseCategory([]);
  //           setCouponData((prev) => ({
  //             ...prev,
  //             couponName: "",
  //             couponCode: "",
  //             couponPercent: "",
  //             minOrderPrice: "",
  //             maxDiscountPrice: "",
  //             couponQuantity: "",
  //             backgroundColourCode: "",
  //             taskColourCode: "",
  //             // expiryDate: "",
  //             startDate: "",
  //             validity: "",
  //             // categoryId: "",
  //             // disable: false,
  //           }));
  //           dispatch(getAllCoupons(`${process.env.REACT_APP_APII}/getAllCouponByAdmin/${admin}`));
  //         }
  //       });
  //     } else {
  //       const formData = new FormData();
  //       // isSelection === "product" &&
  //       //   isProducts &&
  //       //   isProducts?.length > 0 &&
  //       //   isProducts.map((x) => formData.append("product", x));
  //       type === "CATEGORY" &&
  //         isCategory &&
  //         isCategory?.length > 0 &&
  //         isCategory.map((x) => formData.append("categoryId", x));
  //       type === "ECOM_CATEGORY" &&
  //         isCategory &&
  //         isCategory?.length > 0 &&
  //         isCategory.map((x) => formData.append("eComCategoryId", x));

  //       formData.append("icon", isCouponsIcon);
  //       
  //       couponData && Object.entries(couponData).map(([key, value]) => formData.append(key, value));
  //       

  //       dispatch(
  //         createCoupons({
  //           url: `${process.env.REACT_APP_APII}/creatCoupon/${admin}`,
  //           data: formData,
  //         })
  //       ).then((data) => {
  ;
  //         dispatch(
  //           handleAlert({
  //             isOpen: true,
  //             type: `${data?.payload?.success ? "success" : "error"}`,
  //             msg: data?.payload?.message,
  //           })
  //         );
  //         if (data?.payload?.success) {
  //           setIsOpen(false);
  //           setIsOpenUpdate(false);
  //           setIsShow("");
  //           setIsProducts([]);
  //           setIsCategory([]);
  //           // setIseCategory([]);
  //           setCouponData((prev) => ({
  //             ...prev,
  //             couponName: "",
  //             couponCode: "",
  //             couponPercent: "",
  //             minOrderPrice: "",
  //             maxDiscountPrice: "",
  //             couponQuantity: "",
  //             backgroundColourCode: "",
  //             taskColourCode: "",
  //             // expiryDate: "",
  //             startDate: "",
  //             validity: "",
  //             // disable: false,
  //           }));
  //           dispatch(getAllCoupons(`${process.env.REACT_APP_APII}/getAllCouponByAdmin/${admin}`));
  //         }
  //       });
  //     }
  //   } else {
  //     dispatch(
  //       handleAlert({
  //         isOpen: true,
  //         type: "warning",
  //         msg: "all fields is required !",
  //       })
  //     );
  //   }
  // };

 const handleFormSubmit = async (e) => {
  e.preventDefault();

  if (isSubmitting) return;

  setIsSubmitting(true);

  if (isCategory !== "" || isShow !== "") {
    const formData = new FormData();

    const appendCategoryKey =
      singleCoupons?.type === "CATEGORY" || type === "CATEGORY"
        ? "categoryId"
        : "eComCategoryId";

    isCategory?.forEach((x) => formData.append(appendCategoryKey, x));

    formData.append("icon", isCouponsIcon);
    formData.append("couponName", couponData.couponName);
    formData.append("couponCode", couponData.couponCode);
    formData.append("discountType", couponData.discountType);
    formData.append("discountValue", Number(couponData.discountValue || 0));
    formData.append("maxDiscountPrice", couponData.maxDiscountPrice);
    formData.append("minOrderPrice", couponData.minOrderPrice);
    formData.append("couponQuantity", couponData.couponQuantity);
    formData.append("startDate", couponData.startDate);
    formData.append("validity", couponData.validity);
    formData.append("applyOn", couponData.applyOn?.[0] || "ECOMMERCE");

    const apiUrl = isOpenUpdate
      ? `${process.env.REACT_APP_APII}/updateCoupon/${singleCoupons?._id}/${admin}`
      : `${process.env.REACT_APP_APII}/creatCoupon/${admin}`;

    const response = await dispatch(
      isOpenUpdate
        ? updateCoupons({ url: apiUrl, data: formData })
        : createCoupons({ url: apiUrl, data: formData })
    );

    // ✅ SUCCESS / ERROR MESSAGE DISPATCH
    dispatch(
      handleAlert({
        isOpen: true,
        type: response?.payload?.success ? "success" : "error",
        msg: response?.payload?.message,
      })
    );

    if (response?.payload?.success) {
      // ✅ LIST REFRESH
      dispatch(
        getAllCoupons(
          `${process.env.REACT_APP_APII}/getAllCouponByAdmin/${admin}`
        )
      );

      setIsOpen(false);
      setIsOpenUpdate(false);
    }

    setIsSubmitting(false);
  } else {
    dispatch(
      handleAlert({
        isOpen: true,
        type: "warning",
        msg: "All fields are required!",
      })
    );

    setIsSubmitting(false);
  }
};



  return Loading ? (
    <SkLoading />
  ) : (
    <>
      <MDBox
        display="flex"
        alignItems="center"
        lineHeight={1}
        sx={{
          justifyContent: "center",
          textAlign: "center",
          flexDirection: "column",
          gap: 5,
          width: "100%",
        }}
      >
        <Card
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 , 10px",
          }}
        >
          <MDTypography variant="h6" py={0.9}>
            {isOpenUpdate ? `Update Coupon's ` : " Create Coupon's"}
          </MDTypography>
        </Card>
        <MDBox
          display="flex"
          alignItems="center"
          lineHeight={1}
          //   sx={{
          //
          //   }}
          sx={({ palette: { dark, white, info } }) => ({
            border: 0.5,
            borderColor: darkMode ? white.main : dark.main,
            borderRadius: 3,
            p: 3,
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
            gap: 3,
            width: "100%",
          })}
          component="form"
          role="form"
          onSubmit={handleFormSubmit}
        >
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Coupon Name <AstrieskIcon />
            </MDTypography>
            <MDInput
              disabled={createupdateLoading}
              required={true}
              type="text"
              placeholder="Coupon Name"
              fullWidth
              name="couponName"
              value={couponData?.couponName}
              onChange={handleForm}
            />
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Coupon Code <AstrieskIcon />
            </MDTypography>
            <MDInput
              disabled={createupdateLoading}
              required={true}
              type="text"
              placeholder="Coupon Code"
              fullWidth
              name="couponCode"
              value={couponData?.couponCode}
              onChange={handleForm}
            />
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            {/* <MDTypography variant="h6">
              Coupon Percent <AstrieskIcon />
            </MDTypography>
            <MDInput
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Percent fontSize="small" color="white" />
                  </InputAdornment>
                ),
              }}
              disabled={createupdateLoading}
              required={true}
              type="text"
              placeholder="Coupon Percent"
              fullWidth
              name="couponPercent"
              value={couponData?.couponPercent}
              onChange={handleForm}
            /> */}
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Coupon Minimum Order Price <AstrieskIcon />
            </MDTypography>
            <MDInput
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <CurrencyRupee fontSize="small" color="white" />
                  </InputAdornment>
                ),
              }}
              disabled={createupdateLoading}
              required={true}
              type="text"
              placeholder="Min Order Price"
              fullWidth
              name="minOrderPrice"
              value={couponData?.minOrderPrice}
              onChange={handleForm}
            />
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Coupon Maximum Discount Price <AstrieskIcon />
            </MDTypography>
            <MDInput
              disabled={createupdateLoading}
              //  bgColorIcon="info"
              //  icon={{
              //    component: <Percent fontSize="inherit" />,
              //    direction: "right",
              //  }}

              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <CurrencyRupee fontSize="small" color="white" />
                  </InputAdornment>
                ),
              }}
              required={true}
              type="text"
              placeholder="Max Discount  Price"
              fullWidth
              name="maxDiscountPrice"
              value={couponData?.maxDiscountPrice}
              onChange={handleForm}
            />
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Coupon Quantity <AstrieskIcon />
            </MDTypography>
            <MDInput
              disabled={createupdateLoading}
              required={true}
              type="text"
              placeholder="Coupons Quantity"
              fullWidth
              name="couponQuantity"
              value={couponData?.couponQuantity}
              onChange={handleForm}
            />
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Coupon Start Date <AstrieskIcon />
              <MDTypography variant="body1" component="span" fontSize={10}>
                &nbsp; (mm/dd/yyyy)
              </MDTypography>
            </MDTypography>
            <SkDatePicker
              disabled={createupdateLoading}
              initialDate={couponData?.startDate}
              onDateChange={(e) =>
                setCouponData((prev) => ({
                  ...prev,
                  startDate: e,
                }))
              }
              required={true}
              placeholder="Select Date"
              fullWidth={true}
            />
          </MDBox>

          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Coupon Validity <AstrieskIcon />
              <MDTypography variant="body1" component="span" fontSize={10}>
                &nbsp; (validity number&apos;s of only day&apos;s in start the coupons )
              </MDTypography>
            </MDTypography>
            <MDInput
              disabled={createupdateLoading}
              required={true}
              type="text"
              placeholder="Coupons Validity in Day's"
              fullWidth
              name="validity"
              value={couponData?.validity}
              onChange={handleForm}
            />
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            {/* <MDTypography variant="h6">
              Background Color <AstrieskIcon />
              <MDTypography variant="body1" component="span" fontSize={10}>
                &nbsp; (Background Color to Similar color than bette&apos;r UI ; &apos; )
              </MDTypography>
            </MDTypography>
            <MDInput
              disabled={createupdateLoading}
              required={true}
              type="color"
              placeholder=" Background Color"
              fullWidth
              name="backgroundColourCode"
              value={couponData?.backgroundColourCode}
              onChange={handleForm}
            /> */}
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            {/* <MDTypography variant="h6">
              Text Colour Code
              <AstrieskIcon />
              <MDTypography variant="body1" component="span" fontSize={10}>
                &nbsp; (Text Color code to Similar color than bette&apos;r UI ; &apos; )
              </MDTypography>
            </MDTypography>
            <MDInput
              disabled={createupdateLoading}
              required={true}
              type="color"
              placeholder="Text Colour Code"
              fullWidth
              name="taskColourCode"
              value={couponData?.taskColourCode}
              onChange={handleForm}
            /> */}
          </MDBox>

          {/* <MDBox
            lineHeight={1}
            gap={3}
               width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 3,
            }}
          >
            <MDTypography variant="h6">Coupon Expiry Date</MDTypography>
             <MDInput
 required={true}
              inputProps={{
                min: formattedDateServer(new Date(new Date().getTime() + 24 * 60 * 60 * 1000)),
              }}
              type="date"
              placeholder="Coupons expiry Date"
              fullWidth
              name="expiryDate"
              value={couponData?.expiryDate}
              onChange={handleForm}
            />
          </MDBox> */}
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
              // alignItems: "center",
              justifyContent: "center",
              gap: 3,
            }}
          >
           

            <MDBox
              lineHeight={1}
              width={"100%"}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <MDTypography variant="h6" sx={{ my: 2 }}>
                {" "}
                Select Your Category <AstrieskIcon />
              </MDTypography>

              {/* <ApnaSelect
                disabled={createupdateLoading}
                required={true}
                data={
                  singleCoupons?.type === "CATEGORY" || type === "CATEGORY"
                    ? category
                    : EcomCategory
                }
                state={isCategory}
                label="category"
                setState={setIsCategory}
                name="category"
                simpleArray={true}
              /> */}

              <InfiniteApnaSelect
                required={true}
                multi={true}
                disabled={createupdateLoading}
                fetchApi={
                  singleCoupons?.type === "CATEGORY" || type === "CATEGORY"
                    ? `/getAllCategoryByAdmin/${admin}`
                    : `/eCommerce/getAllCategoryByAdmin/${admin}`
                }
                value={isCategory}
                name="productId"
                onChange={(e) => setIsCategory(e.target.value)}
                origin="category"
                valueKey="_id"
                nameKey="name"
                isSimpleArray={false}
              />
            </MDBox>
          </MDBox>
          {/* <MDBox
            display={isOpenUpdate ? "none" : "flex"}
            alignItems="center"
            justifyContent="center"
            lineHeight={1}
            gap={3}
               width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    value={couponData?.disable}
                    checked={couponData?.disable}
                    color={"info"}
                    onChange={
                      (e) =>
                        setCouponData((prev) => ({
                          ...prev,
                          disable: e.target.checked,
                        }))
                      // setcod(e.target.checked)}}
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="disable"
              />
            </FormGroup>
          </MDBox> */}
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Coupon Icon
              <MDTypography variant="body1" component="span" fontSize={11}>
                &nbsp; ( image size - 100 × 100 px )
              </MDTypography>
            </MDTypography>
            
            <ImagePicker
              // required={true}
              name="icon"
              multiple={false}
              images={isCouponsIcon}
              setImages={setIsCouponsIcon}
              //
            />

            {isShow && (
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <span
                  style={{
                    display: "inline-block",
                    width: "50px",
                    height: "50px",
                    margin: "0 0.5rem",
                  }}
                >
                  <img
                    className="Image"
                    style={{ width: "100%", height: "100%" }}
                    src={`${process.env.REACT_APP_URI}/${isShow}`}
                  />
                </span>
                <span
                  className="cross"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setIsShow(null);
                    setIsCouponsIcon("");
                  }}
                >
                  <Cancel
                    sx={({ palette: { dark, white, info } }) => ({
                      color: darkMode ? white?.main : dark.main,
                    })}
                  />
                </span>
              </div>
            )}
          </MDBox>
      <MDBox
  lineHeight={1}
  gap={3}
  width={"90%"}
  sx={{
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
  }}
>
  <MDTypography variant="h6">
    Discount Type <AstrieskIcon />
  </MDTypography>

  <RadioGroup
    row
    value={couponData?.discountType}
    onChange={(e) =>
      setCouponData(prev => ({
        ...prev,
        discountType: e.target.value
      }))
    }
  >
    <FormControlLabel value="FLAT" control={<Radio />} label="FLAT" />
    <FormControlLabel value="PERCENTAGE" control={<Radio />} label="PERCENTAGE" />
  </RadioGroup>
</MDBox>


<MDBox
  lineHeight={1}
  gap={3}
  width={"90%"}
  sx={{
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
  }}
>
  <MDTypography variant="h6">
    Discount Value <AstrieskIcon />
  </MDTypography>

  <MDInput
    required
    type="number"
    placeholder="Enter discount value"
    fullWidth
    name="discountValue"
    value={couponData?.discountValue}
    onChange={handleForm}
  />
</MDBox>


<MDBox
  lineHeight={1}
  gap={3}
  width={"90%"}
  sx={{
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
  }}
>
  <MDTypography variant="h6">
    Apply Coupon On <AstrieskIcon />
  </MDTypography>

  <RadioGroup
    row
    value={couponData?.applyOn?.[0] || ""}
    onChange={(e) =>
      setCouponData(prev => ({
        ...prev,
        applyOn: [e.target.value]
      }))
    }
  >
    <FormControlLabel value="ECOMMERCE" control={<Radio />} label="E-Commerce" />
    <FormControlLabel value="SERVICE" control={<Radio />} label="Service" />
  </RadioGroup>
</MDBox>



          <MDBox
            sx={{
              width: "100%",
              justifyContent: "flex-end",
              textAlign: "center",
              display: "flex",
            }}
          >
            {" "}
            <MDButton
  disabled={createupdateLoading || isSubmitting}
  color="info"
  type="submit"
>

              {createupdateLoading ? (
                <CircularProgress size={20} color="primary" />
              ) : isOpenUpdate ? (
                `Update Coupon `
              ) : (
                `Create Coupon `
              )}
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </>
  );
};

export default Form;
Form.propTypes = {
  isOpenUpdate: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.any,
  setIsOpenUpdate: PropTypes.any,
  type: PropTypes.any,
  filter: PropTypes.any,
};
